/** Editable text/select input */
export const inputCls =
  "w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500";

/** Read-only / pre-populated field */
export const readOnlyCls =
  "w-full rounded-md border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 px-3 py-1 text-sm text-gray-500 dark:text-gray-400 cursor-default";
